import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import awsmobile from './aws-exports';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { generateClient } from 'aws-amplify/api';
import { ApiContext } from './util/context';

dayjs.extend(customParseFormat);

const newAWSMobile = {
  ...awsmobile,
  oauth:{
    domain: process.env.REACT_APP_DOMAIN,
    scope: ['openid', 'email', 'aws.cognito.signin.user.admin'],
    redirectSignIn: process.env.REACT_APP_SIGNIN,
    redirectSignOut: process.env.REACT_APP_SIGNOUT,
    responseType: process.env.REACT_APP_RESPONSETYPE
  },
}
Amplify.configure(newAWSMobile);
const client = generateClient();
const EmployeeApiKeyClient = generateClient({
  endpoint: process.env.REACT_APP_APPSYNC_EMPLOYEE_URL,
  authMode: 'userPool',
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ApiContext.Provider value={{ client, EmployeeApiKeyClient }}>
      <App />
    </ApiContext.Provider>
  </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
